function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M 0 7 L 0 8 L 0 43 L 50 43 L 50 7 L 0 7 z M 2 9 L 48 9 L 48 11.505859 C 47.575713 11.875664 29.813803 27.355977 28.335938 28.642578 C 27.038791 29.771847 25.717322 30.001953 25 30.001953 C 24.283393 30.001953 22.961399 29.772013 21.664062 28.642578 C 20.186197 27.355977 2.4242867 11.875664 2 11.505859 L 2 9 z M 2 14.150391 C 4.4379749 16.275559 18.967648 28.941928 20.353516 30.148438 C 22.05418 31.629002 23.854607 31.998047 25 31.998047 C 26.144678 31.998047 27.94563 31.629168 29.646484 30.148438 C 31.032347 28.941933 45.561926 16.277341 48 14.152344 L 48 41 L 2 41 L 2 14.150391 z"
});

var SvgIcons8NachrichtGefllt100 = function SvgIcons8NachrichtGefllt100(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    viewBox: "0 0 50 50",
    width: "100px",
    height: "100px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcons8NachrichtGefllt100, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons8-nachricht-gefüllt-100.49f359e2.svg";
export { ForwardRef as ReactComponent };